import Button from '@mui/material/Button';
import "./style.module.scss"
import { useContext } from 'react';
import { ModalContext } from '../../contexts/ModalContext';


export default function ButtonGroup({ title, ...props }) {

	const { filter, handleValue } = useContext(ModalContext)

	const {
		id_estagio
	} = filter
	const estagio = id_estagio?.options
	const value = id_estagio?.value

	return (
		<>
			<p style={{ fontSize: '12px', marginBottom: '2px', color: '#2C4992', weight: '400', font: 'roboto' }}>{title}</p>

			{estagio.map((e, i) => {
				return (

					<Button
						size="small"
						style={{ fontSize: '10px', height: '24px', marginRight: '6px', marginTop: '6px' }}
						variant="contained"
						color={!!value.find(values => values.toUpperCase() == e.label.toUpperCase()) ? "blueOcean" : "primary"}
						onClick={() => {
							let valueNew = value
							if(!value.find(values => values.toUpperCase() === e.label.toUpperCase())){
								valueNew.push(e.label)
							} else {
								valueNew = valueNew.filter(values => values.toUpperCase() != e.label.toUpperCase())
							}
							console.log({value, valueNew});
							handleValue({field: "id_estagio", value: valueNew })

						}}
						{...props}
					>{e.label.substring(0, 20)}
					</Button>
				)

			})
			}
		</>
	);
}